import { type FC } from 'react'
import { type AccountOpeningHandoffStep } from '../../../models/AccountOpeningDescriptor'
import { type SubmissionOutcome } from '../domain/connectorResult'
import { handoffCopy } from '../descriptor/stepCopy'

interface HandoffStepProps {
  step: AccountOpeningHandoffStep
  result: SubmissionOutcome | null
}

export const HandoffStep: FC<HandoffStepProps> = ({ step, result }) => {
  const copy = handoffCopy(step)
  const url = result?.handoffUrl ?? null

  return url ? (
    <a className='paragraph-small' href={url} target='_blank' rel='noopener noreferrer'>
      {copy.linkLabel}
    </a>
  ) : (
    <span className='paragraph-small zocks-text-gray-600'>{copy.missing}</span>
  )
}
